export class SymbolDataDownloadLogFilterCriteria {
  type: string;
  dateFrom: Date;
  dateTo: Date;
  user: string;
  company: string;
  downloadedData: string;


  constructor(userChoicesActiveFilters) {
    this.type = userChoicesActiveFilters.type;
    this.dateFrom = userChoicesActiveFilters.dateFrom;
    this.dateTo = userChoicesActiveFilters.dateTo;
    this.user = userChoicesActiveFilters.user;
    this.company = userChoicesActiveFilters.company;
    this.downloadedData = userChoicesActiveFilters.downloadedData;
  }
}
